import React, { useEffect, useState } from 'react';
import MainContentWrapper from '../../Components/MainContentWrapper';
import Popup from '../../ReusableFunctions/Popup';
import { getAllRequests } from '../../apis/adminAPIs/requests';
import { getAllLeadOrders } from '../../apis/adminAPIs/leadOrders';
import AdminRequestTable from './SubComponents/AdminRequestTable';
import StatusCountContainer from './SubComponents/StatusCountContainer';
import { useLocation, useNavigate } from 'react-router';
import { PDRL_ADMIN_ROUTES, PDRL_SUCCESS_ENGI_ROUTES } from '../../routes';
import { getOrdersStatsAPI } from '../../apis/BhuMeetTeams/CustomerSuccessEngineer/orders';
import InteractiveGraph from '../../BhuMeetTeams/BhuMeetFinance/Orders/SubComponents/OrdersGraph';
import { getRequestsCountInInterval } from '../../apis/BhuMeetTeams/CustomerSuccessEngineer/request';
import useWindowSize from '../../hooks/useWindowSize';
import AdminFilterRequest from './SubComponents/AdminFilterRequest';
import LoaderComponent from '../../ReusableComponents/LoaderComponent';
import { Pie } from 'react-chartjs-2';
import NotFounds from '../../ReusableComponents/NotFounds';
import { generateShadesofColor } from '../../ReusableFunctions/reusableFunctions';
import { Button } from '../../Components/Helper';
import CreateOrder from '../../BhuMeetTeams/BhuMeetCustomerSuccess/CreateOrderPopup';


const Requests = ({ dsp }) => {
  const [graphLoading, setGraphLoading] = useState(false);
  const location = useLocation();
  const [cumilativeRequestsGraphData, setCumilativeRequestGraphData] = useState([]);
  const [pieData, setPieData] = useState(null)
  const [openCreateRequestPopup, setOpenCreateRequestPopup] = useState(false);
  const [user, setUser] = useState(undefined);
  const [loading, setLoading] = useState(true)
  const [requests, setRequests] = useState([])
  const [leadRequests, setLeadRequests] = useState([])
  const [activeTab, setActiveTab] = useState("ALL");
  const showLeadOrders = true;

  const [filters, setFilters] = useState(() => {
    const savedFilters = localStorage.getItem('adminRequestFilters')
    if (savedFilters) {
      const parsedFilters = JSON.parse(savedFilters)
      return {
        ...parsedFilters,
        searchQuery: "",
        fromDate: parsedFilters.fromDate ? new Date(parsedFilters.fromDate) : null,
        toDate: parsedFilters.toDate ? new Date(parsedFilters.toDate) : null,
      }
    }
    return {
      services: [],
      statuses: [],
      locations: [],
      states: [],
      isDspActive: true,
      dsps: dsp ? [dsp.dsp_id] : [],
      fromDate: new Date().setHours(0, 0, 0, 0),
      toDate: new Date().setHours(23, 59, 59, 999),
      isFilterByServiceTime: true,
      searchQuery: "",
      orderBy: "time",
      orderType: "DESC",
      pageSize: 15,
      pageNumber: 1,
      interval: "day",
    }
  })
  const [allRequestCount, setAllRequestCount] = useState(0)
  const [view, setView] = useState("tableView");
  const [statusWiseRequestsCount, setStatusWiseRequestsCount] = useState([])
  const [requestsGraphData, setrequestsGraphData] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const { currentWidth } = useWindowSize();
  const navigate = useNavigate();

  const getAllRequestsFunc = async () => {
    try {
      if (activeTab === "LEAD") {
        const data = await getAllLeadOrders({
          ...filters,
          orderBy: filters.orderBy === "last_updated" ? "date_created" : filters.orderBy,
          dspId: dsp ? dsp?.dsp_id : ''
        });
        setLeadRequests(data?.orders || [])
      } else {
        const data = await getAllRequests({ ...filters, isDspActive: true, services: ["Spraying service"] },
          filters.isFilterByServiceTime,
          filters.isFilterByDateCreated
        )
        setRequests(data?.requests)
        setAllRequestCount(data?.requests[0]?.total_count)
      }
      return
    } catch (err) {
      setLoading(false)
      Popup.alert("Error", err, "ERROR")
      return
    }
  }

  const getStatusWiseRequestCountFunc = async () => {
    try {
      const statusRequestCount = await getOrdersStatsAPI({ ...filters, isDspActive: true, services: ["Spraying service"] })
      let statsInfo = statusRequestCount?.stats?.map(s => {
        return {
          status: s.order_status,
          count: s.total_orders,
          amount: s.total_amount,
        };
      }).filter(stat => stat.status !== 'Total Orders');

      setStatusWiseRequestsCount(statsInfo)
      return
    } catch (error) {
      Popup.alert("Error", error, "ERROR")
      return
    }
  }

  const filterChanged = async () => {
    try {
      setLoading(true)
      setRequests([])
      await getStatusWiseRequestCountFunc()
      await getRequestsGraphFunc()
      await getAllRequestsFunc()
      console.log("filters", filters)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      Popup.alert("Error", e, "ERROR")
    }
  }

  const getRequestsGraphFunc = async () => {
    try {
      const data = await getRequestsCountInInterval(
        { ...filters, pageNumber: undefined, pageSize: undefined, services: ["Spraying service"], isDspActive: true, searchQuery: undefined },
        filters.isFilterByServiceTime, undefined
      );
      setrequestsGraphData(data?.graphStats)
      setCumilativeRequestGraphData(data?.commulativeGraphStats)
      if (data?.topPerformingDsps && data?.topPerformingDsps?.length > 0) {
        const topPerfomingDspsLabels = [];
        const topPerfomingDspsRequest = [];
        const totalRequests = data.topPerformingDsps.reduce((sum, dsp) => sum + dsp.total_requests, 0);

        data?.topPerformingDsps?.map((dsp) => {
          const percentage = ((dsp.total_requests / totalRequests) * 100).toFixed(2);
          topPerfomingDspsLabels.push(`${percentage}% - ${dsp.name}`);
          topPerfomingDspsRequest.push(dsp.total_requests);
        });

        const pieData = {
          labels: topPerfomingDspsLabels,
          datasets: [
            {
              data: topPerfomingDspsRequest,
              backgroundColor: generateShadesofColor(topPerfomingDspsRequest.length),
            },
          ],
        };

        setPieData(pieData);
      } else {
        setPieData(null);
      }
      setGraphLoading(false);
      return
    } catch (err) {
      console.log("err", err);
      return
    }
  };

  const handleFilterChanged = (updatedFilters) => {
    setFilters(updatedFilters);
  }

  useEffect(() => {
    // on tab change set searchQuery to null
    setFilters((prevFilters) => {
      const updatedFilters = {
        ...prevFilters,
        searchQuery: "",
        pageNumber: 1,
      };

      localStorage.setItem("adminRequestFilters", JSON.stringify(updatedFilters));
      return updatedFilters;
    });

    console.log("tab changed", localStorage.getItem("adminRequestFilters"));
    filterChanged();
  }, [activeTab]);

  useEffect(() => {
    filterChanged()
    localStorage.setItem("adminRequestFilters", JSON.stringify(filters))
  }, [filters, navigate, dsp])



  return (
    <MainContentWrapper
      containerStyle={{
        padding: "36px 53px"
      }}
    >
      {openCreateRequestPopup &&
        <CreateOrder
          user={user}
          onuserCreate={(createdUser) => {
            setUser(() => createdUser)
            Popup.alert("SUCCESS", "User created successfully !", "SUCCESS");
          }}
          onClose={() => {
            setOpenCreateRequestPopup(false);
            setLoading(true)
            setUser(undefined);
            // if(filters.toDate  ){
            //     const today = new Date();
            //     const toDate = new Date(filters.toDate);
            //     const isSameDate =
            //         toDate.getFullYear() === today.getFullYear() &&
            //         toDate.getMonth() === today.getMonth() &&
            //         toDate.getDate() === today.getDate();
            //         if(isSameDate){
            //             const currentDate = new Date();
            //             const fiveMinutesAhead = new Date(currentDate.getTime() + 1 * 60 * 1000);
            //             setFilters((prev)=>({...prev,toDate:fiveMinutesAhead}))
            //         }
            // }
            getAllRequestsFunc()
            getStatusWiseRequestCountFunc()
            setLoading(false);
          }} />}
      <StatusCountContainer
        requestsStatuses={statusWiseRequestsCount}
        showLeadOrderStats={true}
      />
      <div className='flex justify-between '>
        <div className='request-table-header-title-div' style={{ fontSize: "1.5rem", fontWeight: 700, marginBottom: "15px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }} >
            <div style={{ minWidth: "150px" }} >
              {activeTab == "ALL" ? (
                `${'Requests'} (${requests[0]?.total_count || 0})`
              ) : (
                `${'Lead Orders'} (${leadRequests[0]?.total_count || 0})`
              )}

            </div>
          </div>
        </div>
        {![PDRL_SUCCESS_ENGI_ROUTES.CUSTOMERSUCESSDSPDASHBOARD, PDRL_ADMIN_ROUTES.DSPDASHBOARD].includes(location?.pathname) && (
          <Button
            style={{ height: "33px", fontSize: "14px" }}
            text={"Create Order"}
            onClick={() => {
              setOpenCreateRequestPopup(true);
            }}
          />

        )}
      </div>
      <AdminFilterRequest
        isHideDSPFilter={dsp ? true : false}
        open={openFilter}
        filters={filters}
        onClose={() => setOpenFilter(false)}
        onFilterChange={(filterToBeApply) => {
          // setActiveTab("ALL")
          let updatedFilters = { ...filters, ...filterToBeApply, pageNumber: 1 }
          handleFilterChanged(updatedFilters);
        }}
        setOpenFilter={setOpenFilter}
        screenWidth={currentWidth}
        loading={loading}
        activeTab={activeTab}
      />
      <InteractiveGraph
        showZoom
        data={requestsGraphData}
        title={"Periodic Performance"}
        lineType={0}
        interval={filters?.interval}
        fromDate={filters?.fromDate}
      />
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        {/* Cumulative Performance Graph */}
        <InteractiveGraph
          showZoom
          data={cumilativeRequestsGraphData}
          lineType={0}
          style={{ width: "49%" }}
          title="Cumulative Performance"
          loading={graphLoading}
          loaderWidth="5%"
          loaderHeight="5%"
          isCummulative
          interval={filters.interval}
          fromDate={filters?.fromDate ? new Date(filters?.fromDate) : null}
        />

        {/* Pie Chart Container */}
        <div
          style={{
            height: "500px",
            width: "49%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            background: "white",
            padding: "15px",
          }}
        >
          <div style={{ width: "100%", height: "100%" }}>
            {graphLoading ? (
              <LoaderComponent />
            ) : pieData ? (
              <>
                <div
                  className="flight-graph-container-title"
                  style={{
                    paddingBottom: "10px",
                    fontSize: "18px",
                    fontWeight: "500",
                  }}
                >
                  DSP Performance
                </div>
                <Pie
                  data={pieData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                      animateScale: true,
                      animateRotate: true,
                    },
                    plugins: {
                      legend: {
                        display: true,
                        position: "right",
                        labels: {
                          color: "#1E1E1E",
                          font: {
                            size: 15,
                            weight: "500",
                          },
                        },
                      },
                    },
                    layout: {
                      padding: {
                        top: 50,
                        bottom: 50,
                        left: 50,
                        right: 50,
                      },
                    },
                  }}
                />
              </>
            ) : (
              <NotFounds hideBtn={true} />
            )}
          </div>
        </div>
      </div>

      <AdminRequestTable
        title={"Requests"}
        tabelContainerHeight={"500px"}
        pageNumber={filters.pageNumber}
        requests={activeTab !== "LEAD" ? requests : leadRequests}
        onFilterChange={(filterToBeApply) => {
          const updatedFilters = { ...filters, ...filterToBeApply, pageNumber: filterToBeApply.pageNumber ?? 1 }
          handleFilterChanged(updatedFilters);
        }}
        isHideDSPFilter={dsp ? true : false}
        filters={filters}
        loading={loading}
        totalCount={activeTab !== "LEAD" ? requests[0]?.total_count || 0 : leadRequests[0]?.total_count || 0}
        pageSize={filters.pageSize}
        allCount={allRequestCount}
        onClickRow={(request) => {
          request = { ...request, serviceType: request?.serviceType?.props?.content }
          navigate(`${PDRL_SUCCESS_ENGI_ROUTES.REQUESTDETAILS}`, { state: { request: { type: request.type, id: request.id } } })
        }}
        view={view}
        setView={setView}
        onSearch={(searchQuery) => {
          setFilters((prevFilters) => ({
            ...prevFilters,
            searchQuery,
            pageNumber: 1,
          }))
        }}
        showLeadOrders={showLeadOrders}
        activeTab={activeTab}
        onChangeTab={(value) => {
          setActiveTab(value);
          setFilters((prev) => ({
            ...prev,
            pageNumber: 1,
            searchQuery: ""
          }));
        }}
      />
    </MainContentWrapper>
  )
}

export default Requests